export { default as UserFinMenuProfileInfoMoneyWithTooltip } from './UserFinMenuProfileInfoMoneyWithTooltip';
